import { styled } from '@root/stitches.config';

export const CreateAdminWrapper = styled('div', {
  padding: '$32 0',
  'h3': {
    mb: '$24'
  }
});
